import {useContext, useEffect} from 'react';

import {useQueryClient} from '@tanstack/react-query';
import {Navigate} from 'react-router-dom';

import {UserContext} from '../../../contexts/UserContext/UserContext';
import {logout as authServiceLogout} from '../../../services/auth-service';

export default function LogOutPage() {
  const {userContextLogout, isUserLoggedIn} = useContext(UserContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isUserLoggedIn()) {
      authServiceLogout();
      userContextLogout();
      queryClient.clear();
    }
  }, [isUserLoggedIn, userContextLogout, queryClient]);

  return <Navigate to='/login' />;
}
